$(document).ready( function () {
  var $possible_forms = $('#mc-embedded-subscribe-form, #mc-embedded-subscribe-form-promo-bar');

  if ( $possible_forms.length > 0 ) {
    console.log('forms');
    $('input[type="submit"]', $possible_forms).bind('click', function ( event ) {
      $form = $(this).closest('form');
      if ( event ) event.preventDefault();
      if ( validate_input($form) ) { register($form); }
    });
  }
});

function validate_input($form) {
  if ($('input[name=EMAIL]', $form).val() != '') { return true; }
  else {
    update_status($form, 'Please enter your email in the form above.');
    return false;
  }
}

function update_status($form, status) {
  $('.mc-status', $form).text(status).removeClass('hidden');
}

function register($form) {
//   $.ajax({
//     type: $form.attr('method'),
//     url: $form.attr('action'),
//     data: $form.serialize(),
//     cache       : false,
//     dataType    : 'json',
//     contentType: "application/json; charset=utf-8",
//     error       : function(err) { update_status($form, "Could not connect to the registration server. Please try again later."); },
//     success     : function(data) {
//       if (data.result != "success") {
//         console.log(data.msg);
//         $('.mc-status', $form).html(data.msg).removeClass('hidden')
//       } else {
//         update_status($form, 'Subscribed!');
//         $('input, .signup-message', $form).hide();
//         $('.mc-status', $form).delay(5000).fadeOut(400);
//       }
//     }
//   });
  
  _tbC.saveSubscriptionEmail();
}